const slides = [
  {
    title: "Succulents & Cacti",
    url: "/plants#succulents",
    image: require("../images/SUCCULANTS.jpg"),
    linkText: "Discover resilient desert varieties."
  },
  {
    title: "Tropical Blooms",
    url: "/plants#tropical",
    image: require("../images/tropical.jpg"),
    linkText: "Explore lush, colorful indoor plants."
  },
  {
    title: "Herb Garden Starters",
    url: "/plants#herbs",
    image: require("../images/herbs.jpg"),
    linkText: "Grow your own fresh basil and mint."
  },
  {
    title: "Edible Vegetables",
    url: "/plants#veggies",
    image: require("../images/fruits.jpg"),
    linkText: "See our beginner-friendly tomato plants."
  },
  {
    title: "Low-Light Houseplants",
    url: "/plants#lowlight",
    image: require("../images/infroor house plants.jpg"),
    linkText: "Perfect greenery for darker spaces."
  },
];

export default slides;